// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__39PuP","content":"RecentSearches_content__BdAWv"};